
import { FC } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const BackButton: FC = () => {
  return (
    <div className="mb-6 text-left">
      <Link to="/">
        <Button variant="outline" className="flex items-center gap-2 text-indigo-700 dark:text-indigo-300 border-indigo-300 dark:border-indigo-700 hover:bg-indigo-100 dark:hover:bg-indigo-900/50">
          <ArrowLeft size={16} />
          <span>Back to Home</span>
        </Button>
      </Link>
    </div>
  );
};
